<script>

// import i18nMenu from '@/components/widgets/i18nMenu'
// import {translateApiError} from '@/services/api'

import {mapState} from 'vuex'

// TODO: if general customizations need to be enabled, such as configuring
// where top-level snackbars are positioned - that should be done in
// the vuex store and bound in the app mixin

export default {
  components: {
    // i18nMenu,
  },
  computed: {
    ...mapState('auth', ['authenticated']),
  },
  data () {
    return {
      loaded: false,
    }
  },
  methods: {
    ensureAuth () {
      return new Promise((resolve, reject) => {
        if (this.authenticated) {
          this.loaded = true
          resolve()
          return
        }

        return this.$store.dispatch('auth/initialize')
        .then(resolve)
        .catch(reject)
        .finally(() => {
          this.loaded = true
        })
      })
    },
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
      }).catch(() => {
        // this.$store.dispatch('app/error', translateApiError(e))
      })
    }
  }
}
</script>
